import React from 'react';
import {useQueryString} from '#lib/hooks/use-query-string.js';
import {
    CheckIcon,
    ExclamationTriangleIcon,
    ArrowRightIcon
} from '@heroicons/react/20/solid/index.js';
import Button from '#lib/components/button.jsx';
import {useNavigate} from 'react-router-dom';

function PaymentLandingPage() {
    const navigate = useNavigate();
    const [paymentStatus] = useQueryString('redirect_status', undefined);

    return (
        <div>
            <h2 className="pt-4 text-2xl font-bold mb-6 text-neutral-700">
                {_t.billing.paymentResponse()}
            </h2>

            {paymentStatus === 'succeeded' ? (
                <span className="text-primary-600">
                    <CheckIcon className="icon-sm inline-flex mr-1" />
                    {_t.billing.paymentOkMsg()}
                </span>
            ) : (
                <div className="text-red-600">
                    <ExclamationTriangleIcon className="icon-sm inline-flex mr-1" />
                    {_t.billing.paymentErrorMsg()}
                </div>
            )}

            <div className="mt-14">
                <Button
                    look="primary"
                    onClick={() => navigate('/settings/billing')}
                    size="xl"
                >
                    <ArrowRightIcon className="icon-sm mr-3" />
                    {_t.billing.continue()}
                </Button>
            </div>
        </div>
    );
}

export default PaymentLandingPage;
